/* Maison Byōbu · fiche produit V7 (12/10).
   Le prix expliqué au moment où il apparaît : mur saisi, dimensions imprimées, surface facturée, prix de la matière.
   Lecture seule : tout vient du moteur (mb-cadreur.js : L, H, imp, minM2, prixM2, matiere, tarifImprime). Aucun prix,
   aucune marge et aucune remise ne sont calculés ici autrement que par le moteur. */
(() => {
  const euros = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  const deci = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const sansZero = (n) => euros.format(n).replace(/[,.]00(?=\D)/, '');
  const cm = (v) => String(Math.round(v * 10) / 10).replace('.', ',');

  const brancher = (c) => {
    if (c.mbV7) return;
    c.mbV7 = true;
    const bloc = c.querySelector('[data-mb-v7-calcul]');
    const detail = c.querySelector('[data-mb-v7-detail]');
    const v = (k) => bloc && bloc.querySelector(`[data-v7="${k}"]`);
    const ecrire = (el, t) => { if (el && el.textContent !== t) el.textContent = t; };
    let attente = false;
    // le calcul se lit après le choix des mesures : sous les exemples de formats, avant la vérification humaine
    const formats = bloc && bloc.parentElement.querySelector('.mb-formats');
    if (formats && bloc.previousElementSibling !== formats) formats.after(bloc);

    const maj = () => {
      attente = false;
      const reel = !!(c.L && c.H && c.imp && c.imp.w && c.imp.h && typeof c.tarifImprime === 'function' && c.prixM2);
      if (!reel) {
        if (bloc) bloc.hidden = true;
        ecrire(detail, '');
        return;
      }
      const w = c.imp.w, h = c.imp.h, L = c.L, H = c.H;
      const t = c.tarifImprime(w, h);
      // garde-fou : si le prix du moteur affiché diffère, on se tait et l'on ne montre rien d'autre que le moteur
      if (!t || t.centimes == null || (c.el.prix && c.el.prix.textContent.trim() !== t.prix)) { if (bloc) bloc.hidden = true; ecrire(detail, ''); return; }
      // la surface du moteur : centimètres arrondis, comme tarifImprime
      const cm2 = Math.round(w) * Math.round(h);
      const m2 = cm2 / 1e4;
      const min = c.minM2 || 0;
      const auMinimum = cm2 < min * 1e4;
      const prixM2 = sansZero(c.prixM2);
      const matiere = c.matiere && c.matiere.nom ? c.matiere.nom : '';
      const surface = auMinimum
        ? `${deci.format(m2)} m² imprimés, facturés ${String(min).replace('.', ',')} m² minimum × ${prixM2}/m²`
        : `${deci.format(m2)} m² × ${prixM2}/m²`;
      const margeL = Math.round((w - L) * 10) / 10, margeH = Math.round((h - H) * 10) / 10;

      if (bloc) {
        ecrire(v('mur'), `${cm(L)} × ${cm(H)} cm`);
        ecrire(v('imp'), `${cm(w)} × ${cm(h)} cm`);
        ecrire(v('surface'), surface);
        ecrire(v('matiere'), matiere ? ` · ${matiere}` : '');
        const ligneRemise = bloc.querySelector('[data-v7-ligne="remise"]');
        if (t.palier) {
          const remise = Math.floor(t.centimes * t.palier.pct / 100);
          ecrire(v('remise-nom'), `Tarif grands murs, −${t.palier.pct} %`);
          ecrire(v('remise'), `−${euros.format(remise / 100)}`);
          ligneRemise.hidden = false;
        } else if (ligneRemise) ligneRemise.hidden = true;
        ecrire(v('prix'), t.prix);
        let note = margeL > 0 && margeL === margeH
          ? `Nous ajoutons ${cm(margeL)} cm à la largeur et à la hauteur de votre mur : cette marge facilite les ajustements lors de la pose.`
          : 'Nous imprimons exactement les dimensions indiquées : pensez à ajouter 10 cm à vos mesures (5 cm de chaque côté) pour la marge de coupe.';
        note += auMinimum
          ? ` Pour un petit mur, le prix est calculé sur ${String(min).replace('.', ',')} m², le minimum de commande.`
          : ' Le prix est calculé sur la surface réellement imprimée.';
        ecrire(v('note'), note);
        // le schéma : le mur dans la surface imprimée, aux proportions de l'impression
        const schema = bloc.querySelector('.mb-calcul__imprime');
        if (schema) {
          schema.style.setProperty('--r', String(w / h));
          const mur = schema.firstElementChild;
          mur.style.setProperty('--ix', `${Math.max(4, (w - L) / 2 / w * 100)}%`);
          mur.style.setProperty('--iy', `${Math.max(6, (h - H) / 2 / h * 100)}%`);
        }
        bloc.hidden = false;
      }
      ecrire(detail, `${surface}${matiere ? ` · ${matiere}` : ''}${t.palier ? ` · tarif grands murs −${t.palier.pct} % compris` : ''}`);
    };
    const plus_tard = () => { if (!attente) { attente = true; setTimeout(maj, 0); } };
    c.addEventListener('mb-cadreur:prix', plus_tard);
    c.addEventListener('input', plus_tard);
    c.addEventListener('change', plus_tard);
    c.addEventListener('click', plus_tard);
    // la valeur affichée par le moteur fait foi : on suit son prix
    if (c.el && c.el.prix) new MutationObserver(plus_tard).observe(c.el.prix, { childList: true, characterData: true, subtree: true });
    maj();
  };

  const essayer = (n = 0) => {
    const cadreurs = [...document.querySelectorAll('mb-cadreur')];
    const prets = cadreurs.filter((c) => c.el && c.el.prix);
    prets.forEach(brancher);
    if (prets.length < cadreurs.length && n < 60) setTimeout(() => essayer(n + 1), 150);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => essayer());
  else essayer();
})();

/* L'échantillon en un clic (12/10, demande de Marcel) : depuis la fiche, les liens vers l'échantillon de CETTE œuvre
   (/products/echantillon?variant=…, déjà calculés par snippets/mb-echantillon-url) ajoutent la variante au panier sans
   quitter la page, puis une confirmation discrète propose « Voir le panier ». En cas d'échec : le lien d'origine. */
(() => {
  if (window.mbEchantillonRapide) return;
  window.mbEchantillonRapide = true;
  const style = document.createElement('style');
  style.textContent = `.mb-ech-toast{position:fixed;left:50%;bottom:24px;z-index:2147483000;display:flex;align-items:center;gap:16px;max-width:min(560px,calc(100vw - 32px));padding:14px 18px 14px 20px;border-radius:16px;background:var(--mb-encre,#272018);color:#fff;box-shadow:0 18px 50px rgba(24,20,16,.28);font:400 14.5px/1.45 var(--mb-sans,system-ui);transform:translate(-50%,20px);opacity:0;transition:opacity .3s ease,transform .3s ease;pointer-events:none}
.mb-ech-toast.est-vu{opacity:1;transform:translate(-50%,0);pointer-events:auto}
.mb-ech-toast svg{flex:0 0 18px;width:18px;height:18px;fill:none;stroke:#b9d3b6;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}
.mb-ech-toast a{flex:0 0 auto;color:#fff;font-weight:600;text-decoration:underline;text-underline-offset:3px;white-space:nowrap}
@media (max-width:749px){.mb-ech-toast{left:16px;right:16px;bottom:16px;max-width:none;transform:translateY(20px)}.mb-ech-toast.est-vu{transform:none}}`;
  document.head.append(style);
  let toast, minuteur;
  const montrer = (texte) => {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'mb-ech-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.append(toast);
    }
    toast.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4.5 10.5l3.5 3.5 7.5-8"/></svg><span></span><a href="/cart">Voir le panier</a>';
    toast.querySelector('span').textContent = texte;
    requestAnimationFrame(() => toast.classList.add('est-vu'));
    clearTimeout(minuteur);
    minuteur = setTimeout(() => toast.classList.remove('est-vu'), 7000);
  };
  const bulle = (n) => document.querySelectorAll('cart-icon').forEach((c) => { try { c.renderCartBubble && c.renderCartBubble(n); } catch (e) {} });
  document.addEventListener('click', async (e) => {
    const a = e.target.closest('a[href*="/products/echantillon?variant="]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    const id = parseInt(new URL(a.href, location.origin).searchParams.get('variant'), 10);
    if (!id) return;
    e.preventDefault();
    if (a.dataset.mbAjout === 'en-cours') return;
    a.dataset.mbAjout = 'en-cours';
    a.setAttribute('aria-busy', 'true');
    try {
      const panier = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (panier.items.some((i) => i.variant_id === id)) {
        montrer('L’échantillon de cette œuvre est déjà dans votre panier.');
      } else {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
        if (!r.ok) throw new Error('ajout');
        const apres = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json());
        bulle(apres.item_count);
        montrer('L’échantillon de cette œuvre est ajouté à votre panier.');
      }
      const d = a.closest('dialog');
      if (d && d.open) d.close();
    } catch (err) {
      location.href = a.href;
    } finally {
      delete a.dataset.mbAjout;
      a.removeAttribute('aria-busy');
    }
  });
})();
